<p-dialog
  *ngIf="entitySelectionVisible"
  [header]="entitySelectionHeader"
  [modal]="true"
  [(visible)]="entitySelectionVisible"
  [style]="{ width: '80%' }"
  appendTo="body"
>
  <jml-lib-dynamic-table
    *ngIf="entitySelectionTableData"
    [tableData]="entitySelectionTableData"
    (entitySelection)="entitySelected($event)"
    [isRootEntity]="false"
  ></jml-lib-dynamic-table>
</p-dialog>

<!-- Define the template for dynamic buttons on wizard items-->
<ng-template #buttonTemplate let-button="button">
  <p-button
    *ngIf="!!button"
    [disabled]="button.disabled"
    tabindex="-1"
    class="ml-1"
    (click)="onClickButton(button.id)"
    [icon]="button.icon"
    [label]="button.label"
  />
</ng-template>

<div class="wizard-page-wrapper">
  <p-progressSpinner *ngIf="!wizardForm" strokeWidth="6" class="loading"></p-progressSpinner>

  <form
    class="wizard-form"
    *ngIf="wizardForm"
    [formGroup]="wizardForm"
    autocomplete="off"
    (ngSubmit)="submitWizardForm()"
  >
    <div *ngIf="layout$ | async; let layoutAction">
      <!-- the p-3 is needed to not cut the placeholder of the first form control -->
      <div class="p-3" [style]="scrollPanelStyle" (window:resize)="onWindowResize()">
        <div *ngFor="let wzField of layoutAction.fields; index as i; trackBy: trackByFunction">
          <ng-container [ngSwitch]="wzField.type">
            <!-- Integer -->
            <div *ngSwitchCase="INTEGER_INPUT" class="flex align-items-center">
              <div class="w-full">
                <span class="p-float-label wizard-item">
                  <p-inputNumber
                    [required]="wzField.mandatory ? wzField.mandatory : undefined"
                    [formControl]="getFormControl(wzField.field)"
                    [useGrouping]="false"
                    (onFocus)="onFocus(wzField.field)"
                    (onBlur)="onUpdate(wzField.field)"
                    [inputId]="wzField.header + '-' + wzField.field | lowercase"
                    styleClass="w-full"
                    class="w-full"
                    pAutoFocus
                    [autofocus]="layoutAction.focus === wzField.field"
                    [jmlAutoSelect]
                  ></p-inputNumber>
                  <label [for]="wzField.header + '-' + wzField.field | lowercase">{{ wzField.header }}</label>
                </span>
              </div>
              <ng-container *ngTemplateOutlet="buttonTemplate; context: { button: wzField.button }"></ng-container>
            </div>

            <!-- Float -->
            <div *ngSwitchCase="FLOAT_INPUT" class="flex align-items-center">
              <div class="w-full">
                <span class="p-float-label wizard-item">
                  <p-inputNumber
                    [required]="wzField.mandatory ? wzField.mandatory : undefined"
                    [formControl]="getFormControl(wzField.field)"
                    [useGrouping]="false"
                    [minFractionDigits]="0"
                    [maxFractionDigits]="10"
                    (onFocus)="onFocus(wzField.field)"
                    (onBlur)="onUpdate(wzField.field)"
                    [inputId]="wzField.header + '-' + wzField.field | lowercase"
                    styleClass="w-full"
                    class="w-full"
                    pAutoFocus
                    [autofocus]="layoutAction.focus === wzField.field"
                    [jmlAutoSelect]
                  ></p-inputNumber>
                  <label [for]="wzField.header + '-' + wzField.field | lowercase">{{ wzField.header }}</label>
                </span>
              </div>
              <ng-container *ngTemplateOutlet="buttonTemplate; context: { button: wzField.button }"></ng-container>
            </div>

            <!-- Date -->
            <div *ngSwitchCase="DATE_INPUT" class="flex align-items-center">
              <div class="w-full">
                <span class="p-float-label wizard-item w-full">
                  <p-calendar
                    [required]="wzField.mandatory"
                    [formControl]="getFormControl(wzField.field)"
                    [name]="wzField.field"
                    (onFocus)="onFocus(wzField.field)"
                    (onBlur)="onUpdate(wzField.field)"
                    locale="de"
                    showIcon="true"
                    dateFormat="dd.mm.yy"
                    [id]="wzField.header + '-' + wzField.field | lowercase"
                    firstDayOfWeek="1"
                    appendTo="body"
                    pAutoFocus
                    [autofocus]="layoutAction.focus === wzField.field"
                  >
                  </p-calendar>
                  <label [for]="wzField.header + '-' + wzField.field | lowercase">{{ wzField.header }}</label>
                </span>
              </div>
              <button
                pButton
                tabindex="-1"
                type="button"
                class="ml-1"
                (click)="onClickDelete(wzField.field)"
                icon="pi pi-times"
              ></button>
              <ng-container *ngTemplateOutlet="buttonTemplate; context: { button: wzField.button }"></ng-container>
            </div>

            <!-- Boolean -->
            <div *ngSwitchCase="BOOLEAN_INPUT" class="flex align-items-center">
              <div class="w-full">
                <span class="flex-grow-1 align-self-center">
                  <p-checkbox
                    [required]="wzField.mandatory"
                    [formControl]="getFormControl(wzField.field)"
                    [name]="wzField.field"
                    [binary]="true"
                    [label]="wzField.header"
                    (onChange)="onUpdate(wzField.field)"
                    pAutoFocus
                    [autofocus]="layoutAction.focus === wzField.field"
                  >
                  </p-checkbox>
                </span>
              </div>
              <ng-container *ngTemplateOutlet="buttonTemplate; context: { button: wzField.button }"></ng-container>
            </div>

            <!-- TODO: mit Enrico klären: Soll hier die Typedef angeglichen werden, wäre also wzField.button.buttonId -->
            <jml-lib-label *ngSwitchCase="LABEL" [value]="getFormControl(wzField.field)?.value ?? wzField.value">
              <button
                *ngIf="wzField.buttonId"
                pButton
                type="button"
                class="ml-1"
                [pTooltip]="wzField.buttonTooltip"
                [icon]="wzField.buttonIcon"
                (click)="onClickButton(wzField.buttonId)"
              ></button>
            </jml-lib-label>

            <app-string-input
              *ngSwitchCase="STRING_INPUT"
              class="wizard-item"
              [parentForm]="wizardForm"
              [control]="getFormControl(wzField.field)"
              [placeholder]="wzField.header"
              [showFloatLabel]="true"
              [mandatory]="wzField.mandatory"
              (onEnter)="onUpdate(wzField.field)"
              (onUpdate)="onUpdate(wzField.field)"
              (onFocus)="onFocus(wzField.field)"
              pAutoFocus
              [autofocus]="layoutAction.focus === wzField.field"
              [autoSelect]="true"
            >
              <p-button
                *ngIf="!!wzField.button"
                tabindex="-1"
                class="ml-1"
                [icon]="wzField.button.icon"
                [label]="wzField.button.label"
                (click)="onClickButton(wzField.button.id)"
              />
            </app-string-input>

            <!-- Currency -->
            <jml-lib-currency-control
              *ngSwitchCase="CURRENCY_INPUT"
              [control]="getFormControl(wzField.field)"
              [placeholder]="wzField.header"
              [float]="true"
              (focus)="onFocus(wzField.field)"
              (blur)="onUpdate(wzField.field)"
              pAutoFocus
              [autofocus]="layoutAction.focus === wzField.field"
              [autoSelect]="true"
            >
            </jml-lib-currency-control>

            <jml-lib-wizard-drop-down
              *ngSwitchCase="DROP_DOWN"
              [field]="wzField.field"
              appendTo="body"
              class="wizard-item"
              [parentForm]="wizardForm"
              [control]="getFormControl(wzField.field)"
              [options]="wzField.entries"
              [placeholder]="wzField.header"
              [showDelete]="true"
              [showFloatLabel]="true"
              (onUpdate)="onUpdate(wzField.field)"
              pAutoFocus
              [autofocus]="layoutAction.focus === wzField.field"
              [autoSelect]="true"
              (onFocus)="onFocus(wzField.field)"
            >
              <p-button
                *ngIf="!!wzField.button"
                tabindex="-1"
                class="ml-1"
                [icon]="wzField.button.icon"
                [label]="wzField.button.label"
                (click)="onClickButton(wzField.button.id)"
              />
            </jml-lib-wizard-drop-down>

            <jml-lib-entity-reference-input
              *ngSwitchCase="REFERENCE"
              [control]="getFormControl(wzField.field)"
              [mandatory]="wzField.mandatory"
              [placeholder]="wzField.header"
              [fieldName]="wzField.field"
              [displayName]="wzField.header"
              [referenceType]="wzField.dtoType"
              [referenceFilter]="wzField.referenceFilter"
              [referenceSoftFilter]="wzField.referenceSoftFilter"
              [showFloatLabel]="true"
              [showDelete]="true"
              (onFocus)="onFocus(wzField.field)"
              (onUpdate)="onUpdate(wzField.field)"
              pAutoFocus
              [autofocus]="layoutAction.focus === wzField.field"
            >
              <ng-container *ngTemplateOutlet="buttonTemplate; context: { button: wzField.button }"></ng-container>
            </jml-lib-entity-reference-input>

            <jml-lib-address-control
              *ngSwitchCase="ADDRESS_INPUT"
              [control]="getFormControl(wzField.field)"
              [field]="wzField"
              [header]="wzField.header"
              [required]="wzField.mandatory"
              [autoSelect]="true"
            >
            </jml-lib-address-control>
            <div class="p-2"></div>
            <div *ngSwitchCase="MULTILINE_INPUT" class="flex align-items-start">
              <div class="w-full">
                <jml-lib-multiline-editor
                  [control]="getFormControl(wzField.field)"
                  [height]="wzField.height"
                  [mandatory]="wzField.mandatory"
                  [placeholder]="wzField.header"
                  (onFocus)="onFocus(wzField.field)"
                  (onUpdate)="onUpdate(wzField.field)"
                >
                </jml-lib-multiline-editor>
              </div>
              <ng-container *ngTemplateOutlet="buttonTemplate; context: { button: wzField.button }"></ng-container>
            </div>

            <div *ngSwitchCase="GRID_INPUT" class="flex align-items-start">
              <div class="w-full">
                <jml-lib-grid-input
                  [control]="getFormControl(wzField.field)"
                  [columns]="wzField.columns"
                  [value]="getFormControl(wzField.field).value"
                  [options]="wzField.options"
                  [placeholder]="wzField.header"
                  (onUpdate)="onUpdate(wzField.field)"
                >
                </jml-lib-grid-input>
              </div>
            </div>

            <jml-lib-progress *ngSwitchCase="PROGRESS" [value]="getFormControl(wzField.field)?.value ?? wzField.value">
              <button
                *ngIf="wzField.buttonId"
                pButton
                type="button"
                class="ml-1"
                [pTooltip]="wzField.buttonTooltip"
                [icon]="wzField.buttonIcon"
                (click)="onClickButton(wzField.buttonId)"
              ></button>
            </jml-lib-progress>

            <jml-lib-log
              *ngSwitchCase="LOG"
              [value]="getFormControl(wzField.field)?.value ?? wzField.value"
              [height]="wzField.height"
            >
              <button
                *ngIf="wzField.buttonId"
                pButton
                type="button"
                class="ml-1"
                [pTooltip]="wzField.buttonTooltip"
                [icon]="wzField.buttonIcon"
                (click)="onClickButton(wzField.buttonId)"
              ></button>
            </jml-lib-log>
          </ng-container>
        </div>
      </div>

      <ng-container>
        <div *ngIf="layoutAction.buttons?.length > 0" class="button-row w-full pt-4">
          <div class="flex-child buttons-left">
            <ng-container *ngFor="let button of layoutAction.buttons">
              <p-button
                *ngIf="button.alignment === 'LEFT'"
                (click)="onClickButton(button.id)"
                [disabled]="!!button.disabled"
                [icon]="button.icon"
                [label]="button.label"
              />
            </ng-container>
          </div>
          <div class="flex-child buttons-right">
            <ng-container *ngFor="let button of layoutAction.buttons">
              <p-button
                *ngIf="button.alignment === 'RIGHT'"
                (click)="onClickButton(button.id)"
                [disabled]="!!button.disabled"
                [icon]="button.icon"
                [label]="button.label"
              />
            </ng-container>
          </div>
        </div>
      </ng-container>
    </div>
  </form>
</div>
